import { baseApiUrl } from "../globals.js";
import signInWithEthereum from "../sendSignature.js";
import getConnectedAddress from "../getConnectedAddress.js";

export default async function regenAor(aorId, web3, setInProgress) {
  await setInProgress(true);
  await signInWithEthereum(
    web3,
    `Ape Rides Arena: You are regenerating the image for AOR ID #${aorId}`,
    async (res) => {
      const address = await getConnectedAddress(web3);
      if (res.message && res.admin && res.nonce) {
        await fetch(`${baseApiUrl}/api/generator/regenerateAor`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            nonce: res.nonce,
            caller: address,
            aorId: aorId,
          }),
        }).then(async (res) => {
          const result = await res.json();
          if (result.regenerated) {
            await setInProgress(false);
            window.confirm(result.message);
          } else {
            await setInProgress(false);
            window.confirm(result.message);
          }
        });
      } else {
        await setInProgress(false);
        window.alert("ERROR - SIGNATURE REJECTED");
      }
    }
  ).catch(async (e) => {
    await setInProgress(false);
  });
}
